import { Construction } from "lucide-react";
import { PageHeader } from "@/components/ui/PageHeader";
import { Card, CardBody } from "@/components/ui/card";

export function PlaceholderPage({
  title,
  breadcrumb,
  note,
}: {
  title: string;
  breadcrumb?: string;
  note?: string;
}) {
  return (
    <div>
      <PageHeader title={title} breadcrumb={breadcrumb} />
      <Card>
        <CardBody className="py-16 text-center">
          <div className="inline-grid place-items-center h-14 w-14 rounded-full bg-primary-50 text-primary-600 mb-4">
            <Construction className="h-6 w-6" strokeWidth={1.75} />
          </div>
          <div className="font-serif italic text-2xl text-foreground mb-2">Đang hoàn thiện</div>
          <p className="text-sm text-muted-foreground max-w-md mx-auto">
            {note ?? "Tính năng này đang được phát triển, sẽ có trong bản cập nhật kế tiếp."}
          </p>
        </CardBody>
      </Card>
    </div>
  );
}
